import { ReactFC } from 'src/types';

export const ModalTitle: ReactFC = ({ className, ...props }) => {
  return <p className={`mb-6 text-center text-3xl font-bold ${className}`} {...props} />;
};

export const ModalSubtitle: ReactFC = ({ className, ...props }) => {
  return <p className={`font-semibold text-medium-dark ${className}`} {...props} />;
};
